export default function(storageType) {
  return {
    data: () => ({
      storageItems: {
        loading: true,
        _promise: {
          loading: {},
          loadingResolve: {},
        },
        type: "", // 스토리지 타입
        items: {},
      },
    }),
    async created() {
      const storageItems = this.storageItems;
      if (storageType != null) {
        storageItems.type = storageType;
      } else if (storageItems.type == null || storageItems.type.length === 0) {
        if (this.$route.meta.storageType == null) {
          console.log("not found meta, storageType");
          storageItems.loading = false;
          return;
        }
        storageItems.type = this.$route.meta.storageType;
      }
      // console.log("storage type : ", storageItems.type);

      storageItems._promise.loading = new Promise((_resolve) => {
        storageItems._promise.loadingResolve = _resolve;
      });

      storageItems.items = await this.$store.dispatch("storage/getStorageItem", storageItems.type);
      storageItems.loading = false;
      storageItems._promise.loadingResolve();
    },
    methods: {
      storageWait() {
        const storageItems = this.storageItems;
        if (!storageItems.loading) {
          return new Promise((resolve, reject) => {
            resolve();
          });
        }
        return storageItems._promise.loading;
      },
      saveStorageItems() {
        const vm = this;
        vm.$store.dispatch("storage/setStorageItem", {
          type: vm.storageItems.type,
          items: vm.storageItems.items,
        });
      },
      getStorageItems(key) {
        if (key !== undefined) {
          return this.storageItems.items[key];
        }
        return this.storageItems.items;
      },
      setStorageItem(key, value) {
        // console.log("setStorageItem key : " + key + ", value : ", value);
        const vm = this;
        const storageItems = vm.storageItems;
        const items = storageItems.items;
        items[key] = value;
        this.saveStorageItems();
      },
      removeStorageItems(key) {
        // console.log("removeStorageItem key : ", key);
        const vm = this;
        const storageItems = vm.storageItems;
        if (key == null) {
          storageItems.items = {};
        } else {
          delete storageItems.items[key];
        }
        this.saveStorageItems();
      },
    },
  };
}
